import { NgModule } from '@angular/core';

import { LessonsModule } from '../lessons/lessons.module';
import { NotificationsModule } from '../notifications/notifications.module';
import { SharedModule } from '../shared/shared.module';

import { LectureAddButtonMenuComponent } from './lecture-add-button-menu/lecture-add-button-menu.component';
import { LectureAddButtonComponent } from './lecture-add-button/lecture-add-button.component';
import { LectureBillingButtonComponent } from './lecture-billing-button/lecture-billing-button.component';
import { LectureDetailNavDirective } from './lecture-detail/lecture-detail-nav.directive';
import { LectureDetailComponent } from './lecture-detail/lecture-detail.component';
import { LectureEditButtonComponent } from './lecture-edit-button/lecture-edit-button.component';
import { LectureEditComponent } from './lecture-edit/lecture-edit.component';
import { LectureEnrollButtonComponent } from './lecture-enroll-button/lecture-enroll-button.component';
import { LectureEnrollmentStatusComponent } from './lecture-enrollment-status/lecture-enrollment-status.component';
import { LectureImportButtonComponent } from './lecture-import-button/lecture-import-button.component';
import { LectureLessonsNavDirective } from './lecture-lessons/lecture-lessons-nav.directive';
import { LectureLessonsComponent } from './lecture-lessons/lecture-lessons.component';
import { LectureListComponent } from './lecture-list/lecture-list.component';
import { LectureMemberItemComponent } from './lecture-member-item/lecture-member-item.component';
import { LectureMemberListComponent } from './lecture-member-list/lecture-member-list.component';
import { LectureMembersButtonComponent } from './lecture-members-button/lecture-members-button.component';
import { LectureNavItemComponent } from './lecture-nav-item/lecture-nav-item.component';
import { LectureNavListComponent } from './lecture-nav-list/lecture-nav-list.component';
import { LecturePublicButtonComponent } from './lecture-public-button/lecture-public-button.component';
import { LectureRemoveButtonComponent } from './lecture-remove-button/lecture-remove-button.component';
import { LectureSyllabusComponent } from './lecture-syllabus/lecture-syllabus.component';
import { LectureComponent } from './lecture/lecture.component';
import { LecturesRoutingModule } from './lectures-routing.module';
import { LecturesComponent } from './lectures/lectures.component';
import { LectureAuthGuard } from './shared/lecture-auth.guard';
import { LectureCommentService } from './shared/lecture-comment.service';
import { LectureLessonService } from './shared/lecture-lesson.service';
import { LectureResolver } from './shared/lecture-resolver.service';
import { LectureUserService } from './shared/lecture-user.service';
import { LectureService } from './shared/lecture.service';
import { UiModule } from "../ui/ui.module";

@NgModule({
  imports: [
    SharedModule,
    LessonsModule,
    LecturesRoutingModule,
    NotificationsModule,
    UiModule
  ],
  declarations: [
    LecturesComponent,
    LectureComponent,
    LectureListComponent,
    LectureEditButtonComponent,
    LectureAddButtonComponent,
    LectureDetailComponent,
    LectureDetailNavDirective,
    LectureLessonsComponent,
    LectureLessonsNavDirective,
    LectureNavListComponent,
    LectureNavItemComponent,
    LectureImportButtonComponent,
    LectureEnrollButtonComponent,
    LectureEnrollmentStatusComponent,
    LectureMemberListComponent,
    LectureMemberItemComponent,
    LectureMembersButtonComponent,
    LecturePublicButtonComponent,
    LectureBillingButtonComponent,
    LectureSyllabusComponent,
    LectureEditComponent,
    LectureAddButtonMenuComponent,
    LectureRemoveButtonComponent
  ],
  exports: [
    LectureComponent,
    LectureListComponent,
    LectureAddButtonComponent,
    LectureImportButtonComponent,
    LectureAddButtonMenuComponent
  ],
  providers: [
    LectureService,
    LectureResolver,
    LectureLessonService,
    LectureUserService,
    LectureAuthGuard,
    LectureCommentService,
  ]
})
export class LecturesModule { }



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lectures/lectures.module.ts